import { render, staticRenderFns } from "./ChatterFeedFilter.vue?vue&type=template&id=772b8ad6&scoped=true"
import script from "./ChatterFeedFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatterFeedFilter.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ChatterFeedFilter.vue?vue&type=style&index=0&id=772b8ad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772b8ad6",
  null
  
)

export default component.exports